import styled from 'styled-components'

export const AlertBox = styled.div`
  margin: 15px 0 30px;
  background-color: ${(props) => props.theme.palette.info.light};
  color: ${(props) => props.theme.palette.basic.dark};
  padding: 15px 15px 15px 60px;
  position: relative;

  .fa-exclamation {
    font-size: 13px;
    color: ${(props) => props.theme.palette.info.main};
    position: absolute;
    top: 16px;
    left: 16px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${(props) => props.theme.palette.info.main};
    border-radius: 100px;
  }

  .alert-box-title {
    font-size: 15px;
    margin: 5px 0 10px;
    color: inherit;
  }

  .alert-box-message {
    font-size: 14px;
    margin-bottom: 15px;

    p {
      font-size: inherit;
      margin-bottom: inherit;
    }

    ul,
    ol {
      list-style: revert;
      padding: revert;

      li {
        margin-bottom: 8px;
      }
    }
  }

  .alert-box-cta {
    font-family: ${(props) => props.theme.typography.fontFamily};
    font-size: 15px;
    font-weight: 500;
    background: none;
    border: none;
    padding: 0;
    margin-bottom: 15px;

    &:hover {
      color: ${(props) => props.theme.palette.primary.main};
    }

    .fa-arrow-left {
      font-size: 13px;
      margin-right: 10px;
    }

    .fa-chevron-right {
      font-size: 13px;
      margin-left: 15px;
    }
  }
`
